/**
 * 顯示一個 訊息對話框
 *
 * @param data map 可以包含參數：
 *              title       string  顯示對話框title
 *              msg         html    訊息內容
 *              OK_BUTTON   string  顯示在按鈕上的文字
 */
window.showMessageDialog = function(data) {
    var dialog = $('#message-dialog');
    if(!dialog.length) {
        var dialogHtml =    '<div id="message-dialog" class="dialog message-dialog">' +
                                '<h3 role="title"></h3>' +
                                '<div role="content"></div>' +
                                '<button onclick="closeMessageDialog()">' + (data.OK_BUTTON || 'OK') + '</button>' +
                            '</div>';
        $(document.body).append(dialog = $(dialogHtml));
    }

    dialog.find('[role="title"]').html(data.title);
    dialog.find('[role="content"]').html(data.msg);

    $(document.body).attr('show-dialog', 'message-dialog');
};

/**
 * 關閉訊息對話框
*/

window.closeMessageDialog = function() {
    $(document.body).removeAttr('show-dialog');
};
